export default function LogoMark({ size = 36 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: "block", flexShrink: 0 }}
    >
      <defs>
        <linearGradient id="lm-bg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#152d50" />
          <stop offset="100%" stopColor="#0a1628" />
        </linearGradient>
        <linearGradient id="lm-bar" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#e8c460" />
          <stop offset="100%" stopColor="#b8892a" />
        </linearGradient>
      </defs>

      {/* Fundal rotunjit navy */}
      <rect width="32" height="32" rx="6" fill="url(#lm-bg)" />

      {/* Baseline */}
      <line x1="4" y1="26.5" x2="28" y2="26.5"
        stroke="rgba(255,255,255,0.15)" strokeWidth="0.8" />

      {/* Bare ascendente aurii */}
      <rect x="4"  y="20" width="6"   height="6.5"  rx="1" fill="url(#lm-bar)" opacity="0.85" />
      <rect x="13" y="15" width="6"   height="11.5" rx="1" fill="url(#lm-bar)" />
      <rect x="22" y="9"  width="6"   height="17.5" rx="1" fill="url(#lm-bar)" />

      {/* Cerc + bifă verde (validare) */}
      <circle cx="25" cy="8" r="5.5" fill="#1a6b3a" />
      <polyline
        points="22,8 24.5,10.5 28.5,5.5"
        fill="none"
        stroke="white"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
